export default [
  {
    id: 'pro-1',
    name: 'Gói Pro / 1 Tháng',
    plan: 'Pro',
    title: 'Gói Pro / 1 Tháng',
    subTitle: '',
    price: 250000,
    beforePrice: 0,
    totalMonths: 1,
    description: ['Gia hạn 1 tháng', 'Giới hạn đăng nhập 3 thiết bị'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/autoshopee-pro.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'pro-6',
    name: 'Gói Pro 6 Tháng',
    plan: 'Pro',
    title: 'Gói Pro 6 Tháng',
    subTitle: '',
    price: 1500000,
    beforePrice: 0,
    totalMonths: 7,
    description: ['Tặng 1 tháng', 'Giới hạn đăng nhập 3 thiết bị'],
    promotion: ['Tặng 200 Sao chép Lazada & 200 Tiktok (trị giá 300k)'],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/autoshopee-pro.png',
    badge: 'HOT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'pro-12',
    name: 'Gói Pro 1 năm',
    plan: 'Pro',
    title: 'Gói Pro 1 năm',
    subTitle: '',
    price: 3000000,
    beforePrice: 0,
    totalMonths: 15,
    description: ['Tặng 3 tháng', 'Giới hạn đăng nhập 3 thiết bị'],
    promotion: ['Tặng 500 Sao chép Lazada & 500 Tiktok (trị giá 500k)'],
    hotPrice: 'Chỉ 200k/tháng',
    bestChoice: false,
    logo: '/img/autoshopee-pro.png',
    badge: 'HOT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'pro-24',
    name: 'Gói Pro 2 năm',
    plan: 'Pro',
    title: 'Gói Pro 2 năm',
    subTitle: '',
    price: 6000000,
    beforePrice: 0,
    totalMonths: 36,
    description: ['Tặng 12 tháng', 'Giới hạn đăng nhập 3 + 2 (tặng) = 5 thiết bị'],
    promotion: ['Tặng 1000 Sao chép Lazada & 1000 Tiktok (trị giá 700k)'],
    hotPrice: 'Chỉ 167k/tháng',
    bestChoice: true,
    logo: '/img/autoshopee-pro.png',
    badge: 'MUA 2 TẶNG 1',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'unlimited-1',
    name: 'Gói Unlimited / 1 Tháng',
    plan: 'Unlimited',
    title: 'Gói Unlimited / 1 Tháng',
    subTitle: '',
    price: 500000,
    beforePrice: 0,
    totalMonths: 1,
    description: ['Gia hạn 1 tháng', 'Giới hạn đăng nhập 10 thiết bị'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/autoshopee-unlimited.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'unlimited-6',
    name: 'Gói Unlimited 6 Tháng',
    plan: 'Unlimited',
    title: 'Gói Unlimited 6 Tháng',
    subTitle: '',
    price: 3000000,
    beforePrice: 0,
    totalMonths: 7,
    description: ['Tặng 1 tháng', 'Giới hạn đăng nhập 10 thiết bị'],
    promotion: ['Tặng 200 Sao chép Lazada & 200 Tiktok (trị giá 300k)'],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/autoshopee-unlimited.png',
    badge: 'HOT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'unlimited-12',
    name: 'Gói Unlimited 1 năm',
    plan: 'Unlimited',
    title: 'Gói Unlimited 1 năm',
    subTitle: '',
    price: 6000000,
    beforePrice: 0,
    totalMonths: 15,
    description: ['Tặng 3 tháng', 'Giới hạn đăng nhập 10 thiết bị'],
    promotion: ['Tặng 500 Sao chép Lazada & 500 Tiktok (trị giá 500k)'],
    hotPrice: 'Chỉ 400k/tháng',
    bestChoice: false,
    logo: '/img/autoshopee-unlimited.png',
    badge: 'HOT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'unlimited-24',
    name: 'Gói Unlimited 2 năm',
    plan: 'Unlimited',
    title: 'Gói Unlimited 2 năm',
    subTitle: '',
    price: 12000000,
    beforePrice: 0,
    totalMonths: 36,
    description: ['Tặng 12 tháng', 'Giới hạn đăng nhập 10 + 3 (tặng) = 13 thiết bị'],
    promotion: ['Tặng 1000 Sao chép Lazada & 1000 Tiktok (trị giá 700k)'],
    hotPrice: 'Chỉ 333k/tháng',
    bestChoice: true,
    logo: '/img/autoshopee-unlimited.png',
    badge: 'MUA 2 TẶNG 1',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'deviceExtend',
    name: 'Mở rộng 1 thiết bị / 1 tháng',
    plan: 'deviceExtend',
    title: 'Mở rộng 1 thiết bị / 1 tháng',
    subTitle: '',
    price: 50000,
    beforePrice: 0,
    totalMonths: 0,
    description: ['Mở rộng thiết bị sử dụng ShopManager', 'Liên hệ Sale để được tư vấn'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/device.png',
    badge: null,
    disabled: true,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];
